import Cam from 'components/CardProductScanner/Cam'
import { Button, Modal, Paper, Title } from './styles'
import { usePopup } from 'hooks/usePopup'
import { useNavigate } from 'react-router'
import { useEffect, useState } from 'react'
import { checkBoxesService } from 'services/checkBoxesService'
import { clientLog } from 'services/clientLogService'
import { Box, CircularProgress } from '@material-ui/core'

interface IModalScan {
  open: boolean
  onClose: () => void
}

const ModalScan = ({ open, onClose }: IModalScan) => {
  const { addPopup } = usePopup()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)

  const redirectToConference = async (QRcode: string) => {
    const parts = QRcode.split(';')
    const [rawOrderId, rawBoxNumber] = parts
    const orderId = rawOrderId?.trim()
    const boxNumber = rawBoxNumber?.trim()
    try {
      setIsLoading(true)
      // Formato contratado do QR de caixa: "<pedido numérico>;<caixa>".
      // Rejeita vazio/espaços e qualquer conteúdo fora do formato (separadores de
      // rota "/", caracteres de query/fragmento "?"/"#", etc.).
      const isValidQr =
        QRcode.includes(';') &&
        parts.length === 2 &&
        !!orderId &&
        !!boxNumber &&
        /^\d+$/.test(orderId)
      if (!isValidQr) {
        clientLog({ area: 'conference', event: 'scan_qr_invalido', qrLength: QRcode?.length })
        addPopup({
          title: 'QR Code inválido',
          description: 'O QR Code lido não é de caixa',
          type: 'error',
        })
        return
      }
      clientLog({ area: 'conference', event: 'scan', orderId, boxNumber })
      await checkBoxesService.create(orderId)
      clientLog({ area: 'conference', event: 'scan_ok_navegando', orderId, boxNumber })
      navigate(`../${encodeURIComponent(orderId)}`)
    } catch (error: any) {
      clientLog({ area: 'conference', event: 'scan_erro', orderId, message: error?.message })
      addPopup({
        title: 'Erro ao iniciar conferência',
        description: error?.message,
        type: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  const children = {
    true: (
      <Box padding="3.2rem" display="flex" justifyContent="center">
        <CircularProgress style={{ fontSize: '1.5rem' }} />
      </Box>
    ),
    false: <Cam onSubmit={redirectToConference} loading={isLoading} />,
  }[String(isLoading)]

  return (
    <Modal open={open} onClose={onClose}>
      <Paper>
        <Title>Aponte a câmera para o QR code</Title>
        {children}
        <Button disabled={isLoading} onClick={onClose}>
          Cancelar escaneamento
        </Button>
      </Paper>
    </Modal>
  )
}

export default ModalScan
